// Main Tags Component TypeScript
// Handles tab switching

/**
 * Инициализирует функциональность переключения вкладок основных тегов
 */
export function initMainTags(): void {
  const container = document.querySelector<HTMLElement>('[data-main-tags]')

  if (!container) {
    return
  }

  const tabButtons = container.querySelectorAll<HTMLElement>('[data-tab]')
  const tabContents =
    container.querySelectorAll<HTMLElement>('[data-tab-content]')

  /**
   * Переключает на указанную вкладку
   *
   * @param {string} tabName - Имя вкладки для переключения
   */
  function switchTab(tabName: string): void {
    // Update buttons
    tabButtons.forEach((button) => {
      const isActive = button.dataset.tab === tabName
      button.setAttribute('data-tab-active', String(isActive))
    })

    // Update content
    tabContents.forEach((content) => {
      const isActive = content.dataset.tabContent === tabName
      content.setAttribute('data-tab-active', String(isActive))
    })
  }

  // Add click handlers
  tabButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const tabName = button.dataset.tab
      if (tabName) {
        switchTab(tabName)
      }
    })
  })
}
